import { render } from "./IR_Challan.vue?vue&type=template&id=13654c48"
import script from "./IR_Challan.vue?vue&type=script&lang=js"
export * from "./IR_Challan.vue?vue&type=script&lang=js"

import "./IR_Challan.vue?vue&type=style&index=0&id=13654c48&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__